__turbopack_context__.v({
  "error": "Toast-module__et2GZa__error",
  "info": "Toast-module__et2GZa__info",
  "statusIcon": "Toast-module__et2GZa__statusIcon",
  "success": "Toast-module__et2GZa__success",
  "toast": "Toast-module__et2GZa__toast",
  "warning": "Toast-module__et2GZa__warning",
  "width-grow-f": "Toast-module__et2GZa__width-grow-f",
});
